export default class ArtifactProjectDetails {
  constructor() {
    this.name = "";
    this.description = "";
    this.uploadedFiles = [];
    this.users = [];
  }
}